import { DownloadSimple } from '@/core/ui/icons';
import { Card, ErrorState, Skeleton } from '@/core/ui';
import { useRegistrations } from '../application/queries';
import { registrationsCsv, type Registration } from '../domain/event';

const dateFmt = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

/** Quem se inscreveu, com exportação para planilha (lista de presença). */
export function RegistrationsTable({ eventId }: { eventId: string }) {
  const list = useRegistrations(eventId);

  return (
    <Card className="overflow-hidden">
      <div className="flex items-center justify-between border-b border-line px-5 py-4">
        <h2 className="text-sm font-semibold">
          Inscritos {list.data && <span className="text-fg-subtle">({list.data.length})</span>}
        </h2>
        {list.data && list.data.length > 0 && (
          <button
            type="button"
            onClick={() => download(list.data)}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-teal-600 hover:underline"
          >
            <DownloadSimple aria-hidden className="size-3.5" />
            CSV
          </button>
        )}
      </div>
      {list.isPending ? (
        <Skeleton className="m-5 h-20" />
      ) : list.isError ? (
        <ErrorState error={list.error} className="m-4" />
      ) : list.data.length === 0 ? (
        <p className="px-5 py-8 text-center text-sm text-fg-subtle">Ninguém inscrito ainda.</p>
      ) : (
        <ul className="max-h-[28rem] divide-y divide-line overflow-y-auto">
          {list.data.map((r) => (
            <li key={r.user_id} className="px-5 py-3">
              <p className="truncate text-sm font-medium text-gray-700">{r.full_name || r.email}</p>
              <p className="truncate text-xs text-gray-400">
                {[r.cargo, r.area].filter(Boolean).join(' · ') || r.email} ·{' '}
                {dateFmt.format(new Date(r.registered_at))}
              </p>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}

function download(rows: Registration[]) {
  const url = URL.createObjectURL(new Blob([registrationsCsv(rows)], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'inscritos.csv';
  a.click();
  URL.revokeObjectURL(url);
}
